export type TelemetryPayload = {
  userId: string;
  event: string;
  payload?: Record<string, any>;
  level?: 'info' | 'error';
};

type TelemetryContext = {
  routeName?: string;
  routeFamily?: string;
  workspaceId?: string | null;
  platform?: string;
  appState?: string;
  networkQuality?: string;
  startupMode?: boolean;
  domainOwner?: string;
  freshnessState?: string | null;
  stalePlatforms?: string[];
  startupPhase?: string | null;
};

const globalTelemetryContext: TelemetryContext = {};

const safeStringify = (value: any) => {
  const seen = new WeakSet();
  return JSON.stringify(value, (key, val) => {
    if (val instanceof HTMLElement) {
      return `[HTMLElement ${val.tagName}]`;
    }
    if (typeof val === 'object' && val !== null) {
      if (seen.has(val)) return '[Circular]';
      seen.add(val);
    }
    return val;
  });
};

export const telemetryService = {
  setContext(partial: TelemetryContext) {
    Object.assign(globalTelemetryContext, partial);
  },
  getContext() {
    return { ...globalTelemetryContext };
  },
  track(baseUrl: string, data: TelemetryPayload) {
    try {
      fetch(`${baseUrl}/api/telemetry`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: safeStringify({
          userId: data.userId,
          event: data.event,
          payload: {
            ...globalTelemetryContext,
            ...(data.payload || {})
          },
          level: data.level || 'info'
        })
      }).catch(() => { });
    } catch {
      // ignore
    }
  }
};
